module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_location@2x-3e0b971f7d1c571f0f5b5daa43bbe72a.webp";